import { gql } from '@apollo/client';

export const FETCH_ALL_VISITS_QUERY = gql`
  query fetchAllVisits(
    $visitType: VisitType
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllVisits(
      visitType: $visitType
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      visitsList
      count
    }
  }
`;

export const FETCH_VISIT_DETAILS_BY_ID_QUERY = gql`
  query fetchVisitById($visitId: String) {
    fetchVisitById(visitId: $visitId) {
      encounter
      docArn
      documentReferenceId
    }
  }
`;
